import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const Header = () => {
  // Animation variants for the staggered fade effect
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
        repeat: Infinity,
        repeatType: 'reverse',
        duration: 2
      }
    }
  };
  const arrowVariants = {
    hidden: {
      opacity: 0,
      y: -5
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }
    }
  };
  return <motion.div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-white to-gray-100 px-4" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 1
  }} data-id="element-132">
      <div className="mb-16 flex flex-col items-center" data-id="element-133">
        {/* Intigoo logo flying from right */}
        <motion.div initial={{
        opacity: 0,
        x: 300 // Start off-screen to the right
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3,
        duration: 1.2,
        type: 'spring',
        stiffness: 90
      }} className="mb-8" data-id="element-134">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nGELzLwM8TMD7KS489WXvc/Logo.svg" alt="Intigoo Software Solutions" className="w-full max-w-lg" data-id="element-135" />
        </motion.div>

        {/* Minebea logo flying from left */}
        <motion.div initial={{
        opacity: 0,
        x: -300 // Start off-screen to the left
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3,
        duration: 1.2,
        type: 'spring',
        stiffness: 90
      }} className="mt-8" data-id="element-136"></motion.div>
      </div>
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1.8,
      duration: 0.8
    }} className="mt-12 flex flex-col items-center cursor-pointer" data-id="element-137">
        <p className="text-gray-500 mb-4 font-medium text-xl" data-id="element-138">
          Entdecken Sie unsere Projekte
        </p>
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center" data-id="element-139">
          <motion.div variants={arrowVariants} data-id="element-140">
            <ChevronDownIcon size={36} className="text-[#9CC31C]" data-id="element-141" />
          </motion.div>
          <motion.div variants={arrowVariants} className="-mt-3" data-id="element-142">
            <ChevronDownIcon size={36} className="text-[#9CC31C]" data-id="element-143" />
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>;
};
export default Header;